import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image";
import TruncateMarkup from 'react-truncate-markup'
import { renderRichText } from "gatsby-source-contentful/rich-text"

import * as blogStyles from '../templates/blog.module.scss'


const BlogList = (props) => {
    return (
      <ol className={blogStyles.posts}>
                {props.data.map((edge) => {

                    return (
                      <li key={edge.node.slug} className={blogStyles.post}>
                        <Link to={`/${edge.node.category[0].slug}/${edge.node.slug}`}>
                          <div className={blogStyles.postBox}>
                            <GatsbyImage
                              image={edge.node.thumbnailImage.imgixImage.gatsbyImageData}
                              className={blogStyles.postThumbnail}
                              alt={edge.node.thumbnailImage.description} />
                            <div className={blogStyles.postText}>
                              <h2>{edge.node.blogTitle} <span>{edge.node.subtitle}</span></h2> 
                              <p className={blogStyles.postDateText}>{edge.node.publishedDate}</p>
                              <div className={blogStyles.postPreviewText}>
                                <TruncateMarkup lines={5} tokenize="words">
                                  <div className={blogStyles.postPreviewTextInner}>
                                    {renderRichText(edge.node.bodyExcerptRich)}
                                  </div>
                                </TruncateMarkup>
                              </div>
                              <button className={`btn-color ${blogStyles.readMore}`}>Read More</button>
                            </div>
                          </div>
                        </Link>
                      </li>
                    );
                  })}
              </ol>
    );
}

export default BlogList